module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bkHvU"))).then(() => parcelRequire('hEqeo'));